import { ServiceRequestRepository } from './ServiceRequestAddressUnitRepository'
import ServiceRequestModel from '../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequesAddressUnitController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequesAddressUnitController', new ServiceRequesAddressUnitController())
  }

  async loadForm (params) {
    return await ServiceRequestRepository.loadForm(params)
  }

  async loadCards (params) {
    return await ServiceRequestRepository.loadCards(params)
  }

  async createAddress (params) {
    return await ServiceRequestRepository.createAddress(params)
  }

  async updateAddress (params) {
    return await ServiceRequestRepository.updateAddress(params)
  }
}
